import React from 'react'
import styled from 'styled-components'
import { ImageField, TextField } from '@sentecacommerce-theme/base'
import { LocalLabelsProvider } from '@sentecacommerce-theme/lib'
import { Age } from './Age'
import { Carousel } from '../Common'

export type ShopByAgeProps = {
  data: ShopByAgeItem[]
  labels: ShopByAgeLabels
}

export type ShopByAgeLabels = {
  ariaAndAlt: TextField
}

export type ShopByAgeItem = {
  url: TextField
  image: ImageField
}

const ShopByAge = ({ data, labels }: ShopByAgeProps) => {
  return (
    <LocalLabelsProvider<ShopByAgeLabels> labels={labels}>
      <Container>
        <CarouselContainer>
          <Carousel
            slides={data}
            renderSlide={(item: ShopByAgeItem) => (
              <Age key={`Age__${item.url}`} data={item} />
            )}
          />
        </CarouselContainer>
      </Container>
    </LocalLabelsProvider>
  )
}

const Container = styled.div.attrs({
  className: 'container',
})`
  margin-bottom: -5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    margin-bottom: auto;
  }
`

const CarouselContainer = styled.div`
  /* margin: -1rem 0; */
`

export { ShopByAge }
